import PropTypes from "prop-types";
import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { isNil, uniq, uniqBy } from "lodash";
import { setInitialRating } from "../resource";

class SetRating extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSystem: "",
      selectedValue: "",
      isSubmitting: false,
      success: false,
    };

    this.handleSystemChange = this.handleSystemChange.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidUpdate(prevProps) {
    // Reset selection when ratingSystems prop changes
    if (prevProps.ratingSystems !== this.props.ratingSystems) {
      this.setState({
        selectedSystem: "",
        selectedValue: "",
        success: false,
      });
    }
  }

  handleSystemChange(e) {
    this.setState({
      selectedSystem: e.target.value,
      selectedValue: "",
    });
  }

  handleValueChange(e) {
    this.setState({
      selectedValue: e.target.value,
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { selectedSystem, selectedValue } = this.state;

    if (!selectedSystem || !selectedValue) {
      return;
    }

    const rating = this.props.ratingSystems.find(
      (r) => r.systemCode === selectedSystem && r.systemValue === selectedValue
    );

    if (!isNil(rating)) {
      this.setState({
        isSubmitting: true,
        error: null,
      });
      setInitialRating(rating.sportType, rating.iplayme2Rank)
        .then(() => {
          this.props.refreshTechnicalSkills();
          this.setState({ success: true, isSubmitting: false });
        })
        .catch((err) => {
          this.setState({
            isSubmitting: false,
          });
        });
    }
  }

  render() {
    const { ratingSystems } = this.props;
    const {
      selectedSystem,
      selectedValue,
      isSubmitting,
      success,
    } = this.state;

    const uniqueSystemCodes = uniq(
      ratingSystems.map((r) => r.systemCode).sort((a, b) => a.localeCompare(b))
    );

    // Get rating values for the selected systempope
    const systemValues = selectedSystem
      ? uniqBy(
          ratingSystems
            .filter((r) => r.systemCode === selectedSystem)
            .sort((a, b) => a.iplayme2Rank - b.iplayme2Rank),
          "systemValue"
        )
      : [];

    if (success) {
      return (
        <div className="rating-success">
          <p className="success-message">
            <FormattedMessage
              id="WA.TechSkill.RatingSetSuccess"
              defaultMessage="Rating set successfully!"
            />
          </p>
        </div>
      );
    }

    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <div className="form-group">
            <select
              id="ratingSystem"
              value={selectedSystem}
              onChange={this.handleSystemChange}
              className="form-control"
              style={{
                maxWidth: "200px",
                height: "40px",
                marginBottom: "10px",
              }}
              disabled={isSubmitting}
            >
              <option value="" disabled>
                {this.props.intl.formatMessage({
                  id: "WA.TechSkill.SelectRatingSystem",
                })}
              </option>
              {uniqueSystemCodes.map((systemCode) => (
                <option key={systemCode} value={systemCode}>
                  {systemCode}
                </option>
              ))}
            </select>
          </div>

          {selectedSystem && (
            <div className="form-group">
              <select
                value={selectedValue}
                onChange={this.handleValueChange}
                className="form-control"
                style={{
                  maxWidth: "200px",
                  height: "40px",
                  marginBottom: "10px",
                }}
                disabled={isSubmitting}
              >
                <option value="" disabled>
                  {this.props.intl.formatMessage({
                    id: "WA.TechSkill.SelectRatingValue",
                  })}
                </option>
                {systemValues.map((system) => (
                  <option key={system.systemValue} value={system.systemValue}>
                    {system.systemValue}
                  </option>
                ))}
              </select>
            </div>
          )}

          <button
            type="submit"
            className="btn-gral verde"
            disabled={isSubmitting || !selectedSystem || !selectedValue}
          >
            {isSubmitting ? (
              <FormattedMessage
                id="WA.TechSkill.Submitting"
                defaultMessage="Submitting..."
              />
            ) : (
              <>
                <i className="fas fa-save" />{" "}
                <FormattedMessage
                  id="WA.TechSkill.SaveRating"
                  defaultMessage="Save Rating"
                />
              </>
            )}
          </button>
        </form>
      </div>
    );
  }
}

SetRating.propTypes = {
  ratingSystems: PropTypes.arrayOf(
    PropTypes.shape({
      iplayme2Rank: PropTypes.number,
      systemCode: PropTypes.string,
      systemValue: PropTypes.string,
      discrete: PropTypes.number,
      sportType: PropTypes.string,
    })
  ),
  intl: PropTypes.object.isRequired,
};

SetRating.defaultProps = {
  ratingSystems: [],
};

export default injectIntl(SetRating);
